function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";
import LottieComponent from "components/core/lottie/lottie-component";
import classnames from "classnames";
import { StyledLottieAnimation } from "./lottie-animation-component.scss";
const VISIBLE_PORTION_OF_ANIMATION = 0.8;
class LottieAnimation extends PureComponent {
    onVisibilityChange(isVisible) {
        this.setState({
            isVisible,
            reverseAnimation: !isVisible,
            animationPlayed: isVisible || this.state.animationPlayed
        });
    }
    shouldPlayAnimation() {
        return this.state.isVisible || this.state.animationPlayed;
    }
    render() {
        const { style, animation, fireActionOnFrame, textColor, aboveTheFold } = this.props;
        const { reverseAnimation, isVisible } = this.state;
        const { playOnlyWhenVisible } = animation;
        const isVisibleOffset = parseInt(style.height) * VISIBLE_PORTION_OF_ANIMATION;
        return /*#__PURE__*/ _jsx(StyledLottieAnimation, {
            style: style,
            color: style.color || textColor,
            className: classnames("lottie-animation-component", {
                "above-the-fold": aboveTheFold
            }),
            children: /*#__PURE__*/ _jsx(VisibilitySensor, {
                offset: {
                    bottom: isVisibleOffset,
                    top: -10000
                },
                partialVisibility: true,
                onChange: this.onVisibilityChange,
                active: playOnlyWhenVisible,
                scrollCheck: playOnlyWhenVisible,
                children: /*#__PURE__*/ _jsx(LottieComponent, _object_spread_props(_object_spread({}, animation), {
                    shouldPlay: this.shouldPlayAnimation(),
                    reverseAnimation: reverseAnimation,
                    fireActionOnFrame: fireActionOnFrame,
                    aboveTheFold: aboveTheFold
                }))
            })
        });
    }
    constructor(props){
        super(props);
        this.onVisibilityChange = this.onVisibilityChange.bind(this);
        this.state = {
            isVisible: false,
            reverseAnimation: false,
            animationPlayed: false
        };
    }
}
export { LottieAnimation as default };
LottieAnimation.defaultProps = {
    style: {
        height: "100px",
        animation: {}
    },
    animation: {
        loop: false,
        autoplay: false,
        playOnlyWhenVisible: true,
        jsonPath: "/static/lottie/arrow-swirl-down.json"
    }
};
